// Auto-generated logo mappings - canonical code → logo filename
// Logo paths: /logos/teams/{league}/{filename}

export const NFL_LOGOS = {
  ARI: 'Cardinals.png', ATL: 'Falcons.png', BAL: 'Ravens.png', BUF: 'Bills.png',
  CAR: 'Panthers.png', CHI: 'Bears.png', CIN: 'Bengals.png', CLE: 'Browns.png',
  DAL: 'Cowboys.png', DEN: 'Broncos.png', DET: 'Lions.png', GB: 'Packers.png',
  HOU: 'Texans.png', IND: 'Colts.png', JAX: 'Jaguars.png', KC: 'Chiefs.png',
  LAC: 'Chargers.png', LAR: 'Rams.png', LV: 'Raiders.png', MIA: 'Dolphins.png',
  MIN: 'Vikings.png', NE: 'Patriots.png', NO: 'Saints.png', NYG: 'Giants.png',
  NYJ: 'Jets.png', PHI: 'Eagles.png', PIT: 'Steelers.png', SEA: 'Seahawks.png',
  SF: '49ers.png', TB: 'Buccaneers.png', TEN: 'Titans.png', WAS: 'Commanders.png', WSH: 'Commanders.png'
}

export const NBA_LOGOS = {
  ATL: 'Hawks.svg', BOS: 'Celtics.svg', BKN: 'Nets.svg', CHA: 'Hornets.svg',
  CHI: 'Bulls.svg', CLE: 'Cavaliers.svg', DAL: 'Mavericks.svg', DEN: 'Nuggets.svg',
  DET: 'Pistons.svg', GSW: 'Warriors.svg', GS: 'Warriors.svg', HOU: 'Rockets.svg', IND: 'Pacers.svg',
  LAC: 'Clippers.svg', LAL: 'Lakers.svg', MEM: 'Grizzlies.svg', MIA: 'Heat.svg',
  MIL: 'Bucks.svg', MIN: 'Timberwolves.svg', NOP: 'Pelicans.svg', NO: 'Pelicans.svg',
  NYK: 'Knicks.svg', NY: 'Knicks.svg',  // NY alias for ESPN
  OKC: 'Thunder.svg', ORL: 'Magic.svg', PHI: '76ers.svg', PHX: 'Suns.svg', PHO: 'Suns.svg',
  POR: 'Trail Blazers.svg', SAC: 'Kings.svg', SAS: 'Spurs.svg', SA: 'Spurs.svg',  // SA alias for ESPN
  TOR: 'Raptors.svg', UTA: 'Jazz.svg', UTAH: 'Jazz.svg', WAS: 'Wizards.svg', WSH: 'Wizards.svg'
}

export const NHL_LOGOS = {
  ANA: 'Ducks.png', ARI: 'Coyotes.png', BOS: 'Bruins.png', BUF: 'Sabres.png',
  CAR: 'Hurricanes.png', CBJ: 'Blue Jackets.png', CGY: 'Flames.png', CHI: 'Blackhawks.png',
  COL: 'Avalanche.png', DAL: 'Stars.png', DET: 'Red Wings.png', EDM: 'Oilers.png',
  FLA: 'Panthers.png', LA: 'Kings.png', LAK: 'Kings.png', MIN: 'Wild.png', MTL: 'Canadiens.png',
  NJ: 'Devils.png', NJD: 'Devils.png', NSH: 'Predators.png', NYI: 'Islanders.png', NYR: 'Rangers.png',
  OTT: 'Senators.png', PHI: 'Flyers.png', PIT: 'Penguins.png', SEA: 'Kraken.png',
  SJS: 'Sharks.png', STL: 'Blues.png', TB: 'Lightning.png', TBL: 'Lightning.png', TOR: 'Maple Leafs.png',
  UTA: 'Mammoth.png',  // Utah Mammoth (2025-12-17)
  VAN: 'Canucks.png', VGK: 'Golden Knights.png', WPG: 'Jets.png', WSH: 'Capitals.png'
}

export const MLB_LOGOS = {
  ARI: 'Diamondbacks.png', ATL: 'Braves.png', BAL: 'Orioles.png', BOS: 'Red Sox.png',
  CHC: 'Cubs.png', CHW: 'White Sox.png', CWS: 'White Sox.png', CIN: 'Reds.png', CLE: 'Guardians.png',
  COL: 'Rockies.png', DET: 'Tigers.png', HOU: 'Astros.png', KCR: 'Royals.png',
  LAA: 'Angels.png', LAD: 'Dodgers.png', MIA: 'Marlins.png', MIL: 'Brewers.png',
  MIN: 'Twins.png', NYM: 'Mets.png', NYY: 'Yankees.png', OAK: 'Athletics.png',
  PHI: 'Phillies.png', PIT: 'Pirates.png', SDP: 'Padres.png', SEA: 'Mariners.png',
  SFG: 'Giants.png', STL: 'Cardinals.png', TBR: 'Rays.png', TEX: 'Rangers.png',
  TOR: 'Blue Jays.png', WSH: 'Nationals.png'
}

// CBB/NCAA uses school names mapped to NCAA folder logos
// Only includes schools whose logos exist in public/logos/teams/ncaa/
// ESPN logos added 2025-12-15 - format: {espn_id}_{abbreviation}.png
export const CBB_LOGOS = {
  // SEC
  ALA: 'alabama.png', AUB: 'auburn.png', UGA: 'georgia.png', LSU: 'lsu.png',
  TENN: 'tennessee.png', FLA: 'florida.png', TAMU: 'texasAM.png', MISS: 'oleMiss.png',
  MSST: 'mississippiState.png', ARK: 'arkansas.png', MIZZ: 'missouri.png', VAN: 'vanderbilt.png',
  UK: 'kentucky.png', SCAR: 'southCarolina.png',
  // Big Ten
  OSU: 'ohioState.png', MICH: 'michigan.png', PSU: 'pennState.png', MSU: 'michiganState.png',
  WIS: 'wisconsin.png', IOWA: 'iowa.png', NEB: 'nebraska.png', NW: 'northwestern.png', NU: 'northwestern.png',
  MINN: 'minnesota.png', ILL: 'illinois.png', IND: 'indiana.png', PUR: 'purdue.png',
  RUT: 'rutgers.png', MD: 'maryland.png',
  // Big 12
  TEX: 'texas.png', OU: 'oklahoma.png', OKST: 'OklahomaState.png', BAY: 'baylor.png',
  TCU: 'TCU.png', TTU: 'texasTech.png', KSU: 'kansasState.png', KU: 'kansas.png',
  ISU: 'iowaState.png', WVU: 'westVirginia.png', CIN: 'cincinnati.png', UCF: 'ucf.png',
  HOU: 'houston.png', BYU: 'byu.png', ARIZ: 'arizona.png', ASU: 'arizonaState.png',
  COLO: 'colorado.png', UTAH: 'utah.png',
  // Pac-12 / Big West
  USC: 'usc.png', UCLA: 'ucla.png', ORE: 'oregon.png', ORST: 'oregonState.png',
  WASH: 'washington.png', WSU: 'washingtonState.png', CAL: 'california.png', STAN: 'stanford.png',
  // ACC
  CLEM: 'clemson.png', FSU: 'floridaState.png', MIA: 'miami.png', VT: 'virginiaTech.png',
  UVA: 'virginia.png', UNC: 'northCarolina.png', NCST: 'ncState.png', DUKE: 'duke.png',
  WAKE: 'wakeForest.png', BC: 'boston.png', LOU: 'louisville.png', PITT: 'pittsburgh.png',
  SYR: 'syracuse.png', GT: 'georgiaTech.png', ND: 'notreDame.png',
  // Big East
  NOVA: 'villanova.png', GTOWN: 'georgetown.png', BUTLER: 'butler.png', CONN: 'connecticut.png',
  // A10 / Mid-majors
  DAYT: 'dayton.png', RICH: 'richmond.png', FORD: 'fordham.png', DUQU: 'duquesne.png',
  UMASS: 'massachusetts.png',
  // Missouri Valley
  DRAKE: 'drake.png', ISIL: 'illinoisState.png', ILST: 'illinoisState.png', MIST: 'missouriState.png',
  INST: 'indianaState.png', VALS: 'valparaiso.png', NIOWA: 'northernIowa.png',
  // Sun Belt / Conference USA / etc
  TROY: 'troy.png', STFPA: 'stFrancisPA.png', CAMP: 'campbell.png', SAMF: 'samford.png',
  EWASH: 'easternWashington.png', PRTST: 'portlandState.png', HOUST: 'houstonBaptist.png',
  SDST: 'southDakotaState.png',
  // UC system
  DAVIS: 'ucDavis.png', SDIEGO: 'sanDiego.png', SDSU: 'sanDiegoState.png',
  // Other schools with NCAA logos
  TARL: 'tarleton.png', MEMPH: 'memphis.png', NAVY: 'navy.png', ARMY: 'army.png',
  MRSH: 'marshall.png', RICE: 'rice.png', SMU: 'smu.png', TUL: 'tulane.png',
  TLSA: 'tulsa.png', USF: 'southFlorida.png', FAU: 'floridaAtlantic.png', UAB: 'uab.png',

  // === ESPN Downloaded Logos (2025-12-15) ===
  // Format: {espn_id}_{abbreviation}.png - These map receiver codes to ESPN logo files

  // Teams reported missing earlier
  ETAM: '2837_ETAM.png',    // East Texas A&M Lions
  SELA: '2545_SELA.png',    // Southeastern Louisiana Lions
  RHO: '2519_RHO.png',      // Rhode Island Rams (receiver uses RHO)
  URI: 'rhodeIsland.png',   // Rhode Island (alternate code)
  UIW: '2916_UIW.png',      // Incarnate Word Cardinals
  UNA: '2453_UNA.png',      // North Alabama Lions
  AAMU: '2010_AAMU.png',    // Alabama A&M Bulldogs
  MCN: '2377_MCN.png',      // McNeese Cowboys
  MCNSE: '2377_MCN.png',    // McNeese (receiver alias)
  GWU: '2241_GWEB.png',     // Gardner-Webb (receiver uses GWU)
  GWEB: '2241_GWEB.png',    // Gardner-Webb Runnin Bulldogs

  // SWAC Conference
  ALST: '2011_ALST.png',    // Alabama State
  GRAM: '2755_GRAM.png',    // Grambling State
  JKST: '2296_JKST.png',    // Jackson State
  MVSU: '2400_MVSU.png',    // Mississippi Valley State
  MVST: '2400_MVSU.png',    // Mississippi Valley State (alias)
  PRVU: '2504_PV.png',      // Prairie View A&M
  PV: '2504_PV.png',        // Prairie View A&M (ESPN code)
  SOUT: '2582_SOU.png',     // Southern University
  SOU: '2582_SOU.png',      // Southern University (ESPN code)
  TXSO: '2640_TXSO.png',    // Texas Southern
  UAPB: '2029_UAPB.png',    // Arkansas Pine Bluff
  ALCN: '2016_ALCN.png',    // Alcorn State
  ALCO: '2016_ALCN.png',    // Alcorn State (alias)

  // MEAC Conference
  BCOO: '2065_BCU.png',     // Bethune-Cookman
  BCU: '2065_BCU.png',      // Bethune-Cookman (ESPN code)
  COPP: '2154_COPP.png',    // Coppin State
  DSU: '2169_DSU.png',      // Delaware State
  DELST: '2169_DSU.png',    // Delaware State (alias)
  FAMU: '50_FAMU.png',      // Florida A&M
  HAMP: '2261_HAMP.png',    // Hampton
  HOW: '47_HOW.png',        // Howard
  MORG: '2415_MORG.png',    // Morgan State
  NCAT: '2448_NCAT.png',    // NC A&T
  NCCU: '2428_NCCU.png',    // NC Central
  NCCEN: '2428_NCCU.png',   // NC Central (alias)
  NORF: '2450_NORF.png',    // Norfolk State
  NSU: '2450_NORF.png',     // Norfolk State (alias)
  SCST: '2569_SCST.png',    // SC State
  UMES: '2379_UMES.png',    // Maryland Eastern Shore

  // OVC / ASUN / Southland
  APSU: '2046_APSU.png',    // Austin Peay
  BEL: '2057_BEL.png',      // Bellarmine
  BELL: '2057_BEL.png',     // Bellarmine (alias)
  EKU: '2198_EKU.png',      // Eastern Kentucky
  JXST: '55_JXST.png',      // Jacksonville State
  JVST: '55_JXST.png',      // Jacksonville State (alias)
  LIP: '288_LIP.png',       // Lipscomb
  MORE: '2413_MORE.png',    // Morehead State
  MUR: '93_MUR.png',        // Murray State
  MURR: '93_MUR.png',       // Murray State (alias)
  SEMO: '2546_SEMO.png',    // SE Missouri State
  TNTC: '2635_TNTC.png',    // Tennessee Tech
  TNST: '2634_TNST.png',    // Tennessee State
  UTM: '2630_UTM.png',      // UT Martin

  // Southland / WAC
  ACU: '2000_ACU.png',      // Abilene Christian
  CARK: '2110_CARK.png',    // Central Arkansas
  HCU: '2277_HCU.png',      // Houston Christian
  LAM: '2320_LAM.png',      // Lamar
  NICH: '2447_NICH.png',    // Nicholls State
  NWST: '2466_NWST.png',    // Northwestern State
  ORU: '198_ORU.png',       // Oral Roberts
  SFA: '2617_SFA.png',      // Stephen F. Austin
  SHSU: '2534_SHSU.png',    // Sam Houston State
  SAM: '2535_SAM.png',      // Samford
  TAR: '2627_TAR.png',      // Tarleton State (ESPN code)

  // Big Sky
  EWU: '331_EWU.png',       // Eastern Washington (ESPN code)
  IDHO: '70_IDHO.png',      // Idaho
  IDAHO: '70_IDHO.png',     // Idaho (alias)
  IDST: '304_IDST.png',     // Idaho State
  MONT: '149_MONT.png',     // Montana
  MTST: '147_MTST.png',     // Montana State
  NAU: '2464_NAU.png',      // Northern Arizona
  UND: '155_UND.png',       // North Dakota
  NDSU: '2449_NDSU.png',    // North Dakota State
  PRST: '2502_PRST.png',    // Portland State (ESPN code)
  SAC: '16_SAC.png',        // Sacramento State
  SUU: '253_SUU.png',       // Southern Utah
  WEB: '2692_WEB.png',      // Weber State
  UNCO: '2458_UNCO.png',    // Northern Colorado

  // Summit / Horizon
  DEN: '2172_DEN.png',      // Denver
  KC: '140_KC.png',         // UMKC
  UMKC: '140_KC.png',       // UMKC (alias)
  OAK: '2473_OAK.png',      // Oakland
  OMA: '2437_OMA.png',      // Omaha
  SDAK: '233_SDAK.png',     // South Dakota
  GB: '2739_GB.png',        // Green Bay
  WRST: '2750_WRST.png',    // Wright State
  CLST: '325_CLE.png',      // Cleveland State
  CLE: '325_CLE.png',       // Cleveland State (ESPN code)
  DET: '2174_DETM.png',     // Detroit Mercy
  DETM: '2174_DETM.png',    // Detroit Mercy (ESPN code)
  MIL: '270_MILW.png',      // Milwaukee
  MILW: '270_MILW.png',     // Milwaukee (ESPN code)
  NKU: '94_NKU.png',        // Northern Kentucky
  PFW: '2870_PFW.png',      // Purdue Fort Wayne
  YSU: '2754_YSU.png',      // Youngstown State
  IUIN: '85_IUIN.png',      // IU Indianapolis

  // WCC
  GONZ: '2250_GONZ.png',    // Gonzaga
  STMRY: '2608_SMC.png',    // Saint Mary's
  SMC: '2608_SMC.png',      // Saint Mary's (ESPN code)
  SANFR: '2539_SF.png',     // San Francisco
  SF: '2539_SF.png',        // San Francisco (ESPN code)
  PEPP: '2492_PEPP.png',    // Pepperdine
  LMU: '2351_LMU.png',      // Loyola Marymount
  LMCHI: '2351_LMU.png',    // Loyola Marymount (alias)
  PORT: '2501_PORT.png',    // Portland
  SANTA: '2541_SCU.png',    // Santa Clara
  SCU: '2541_SCU.png',      // Santa Clara (ESPN code)
  USD: '301_USD.png',       // San Diego
  PACIF: '279_PAC.png',     // Pacific
  PAC: '279_PAC.png',       // Pacific (ESPN code)

  // Big West / WAC
  CSUB: '2934_CSUB.png',    // CSU Bakersfield
  CSBAK: '2934_CSUB.png',   // CSU Bakersfield (alias)
  CSUF: '2239_CSUF.png',    // CSU Fullerton
  CSUN: '2463_CSUN.png',    // CSU Northridge
  LBSU: '299_LBSU.png',     // Long Beach State
  UCI: '300_UCI.png',       // UC Irvine
  UCIRVN: '300_UCI.png',    // UC Irvine (alias)
  UCR: '27_UCR.png',        // UC Riverside
  UCRIV: '27_UCR.png',      // UC Riverside (alias)
  UCSB: '2540_UCSB.png',    // UC Santa Barbara
  UCSD: '28_UCSD.png',      // UC San Diego
  UCD: '302_UCD.png',       // UC Davis (ESPN code)
  HAW: '62_HAW.png',        // Hawaii
  CBU: '2856_CBU.png',      // Cal Baptist
  CALB: '2856_CBU.png',     // Cal Baptist (alias)
  UVU: '3084_UVU.png',      // Utah Valley
  UTUV: '3084_UVU.png',     // Utah Valley (alias)
  GCU: '2253_GCU.png',      // Grand Canyon
  UTU: '3101_UTU.png',      // Utah Tech
  UTTCH: '3101_UTU.png',    // Utah Tech (alias)
  SEA: '2547_SEA.png',      // Seattle
  TAR: '2627_TAR.png',      // Tarleton
  RGV: '292_RGV.png',       // UT Rio Grande Valley
  UTRGV: '292_RGV.png',     // UT Rio Grande Valley (alias)
  UTA: '250_UTA.png',       // UT Arlington

  // CAA / Patriot
  CHST: '2130_CHST.png',    // Charleston Southern
  COFC: '232_COFC.png',     // College of Charleston (keep existing)
  DREX: '2182_DREX.png',    // Drexel
  ELON: '2210_ELON.png',    // Elon
  HOF: '2275_HOF.png',      // Hofstra
  HOFS: '2275_HOF.png',     // Hofstra (alias)
  JMU: '256_JMU.png',       // James Madison
  NEU: '111_NE.png',        // Northeastern (ESPN code NE)
  NE: '111_NE.png',         // Northeastern (ESPN code)
  STBK: '2619_STBK.png',    // Stony Brook
  STON: '2619_STBK.png',    // Stony Brook (alias)
  TOW: '119_TOW.png',       // Towson
  UNCW: '350_UNCW.png',     // UNC Wilmington
  WM: '2729_W&M.png',       // William & Mary
  BUCK: '2083_BUCK.png',    // Bucknell
  COLG: '2142_COLG.png',    // Colgate
  HC: '107_HC.png',         // Holy Cross
  LAF: '322_LAF.png',       // Lafayette
  LEH: '2329_LEH.png',      // Lehigh
  BU: '104_BU.png',         // Boston University
  AME: '44_AMER.png',       // American
  AMER: '44_AMER.png',      // American (ESPN code)

  // SoCon / Big South
  CIT: '2643_CIT.png',      // The Citadel
  ETSU: '2193_ETSU.png',    // East Tennessee State
  FUR: '231_FUR.png',       // Furman
  MERC: '2385_MERC.png',    // Mercer
  UNCG: '2430_UNCG.png',    // UNC Greensboro
  CHAT: '236_UTC.png',      // Chattanooga
  UTC: '236_UTC.png',       // Chattanooga (ESPN code)
  VMI: '2678_VMI.png',      // VMI
  WCU: '2717_WCU.png',      // Western Carolina
  WOF: '2747_WOF.png',      // Wofford
  CAM: '2097_CAM.png',      // Campbell (ESPN code)
  HPU: '2272_HPU.png',      // High Point
  LONG: '2344_LONG.png',    // Longwood
  PRES: '2506_PRES.png',    // Presbyterian
  RAD: '2515_RAD.png',      // Radford
  UPST: '2908_UPST.png',    // USC Upstate
  WIN: '2737_WIN.png',      // Winthrop
  WINT: '2737_WIN.png',     // Winthrop (alias)

  // MAAC / NEC / America East
  CAN: '2099_CAN.png',      // Canisius
  FAIR: '2217_FAIR.png',    // Fairfield
  IONA: '314_IONA.png',     // Iona
  MAN: '2363_MAN.png',      // Manhattan
  MANH: '2363_MAN.png',     // Manhattan (alias)
  MRST: '2368_MRST.png',    // Marist
  MARIS: '2368_MRST.png',   // Marist (alias)
  NIA: '315_NIA.png',       // Niagara
  NIAG: '315_NIA.png',      // Niagara (alias)
  QUIN: '2514_QUIN.png',    // Quinnipiac
  QUINN: '2514_QUIN.png',   // Quinnipiac (alias)
  RID: '2520_RID.png',      // Rider
  SPU: '2612_SPU.png',      // Saint Peter's
  STPT: '2612_SPU.png',     // Saint Peter's (alias)
  SIE: '2561_SIE.png',      // Siena
  SIEN: '2561_SIE.png',     // Siena (alias)
  FDU: '161_FDU.png',       // FDU
  LIU: '112358_LIU.png',    // Long Island
  SHU: '2529_SHU.png',      // Sacred Heart
  WAG: '2681_WAG.png',      // Wagner
  CCSU: '2115_CCSU.png',    // Central Connecticut State
  MERR: '2771_MRMK.png',    // Merrimack
  MRMK: '2771_MRMK.png',    // Merrimack (ESPN code)
  ME: '311_ME.png',         // Maine
  NHAV: '2441_NHVN.png',    // New Haven
  NHVN: '2441_NHVN.png',    // New Haven (ESPN code)
  UNH: '160_UNH.png',       // New Hampshire
  UVM: '261_UVM.png',       // Vermont
  BING: '2066_BING.png',    // Binghamton
  ALB: '399_UALB.png',      // Albany
  UALB: '399_UALB.png',     // Albany (ESPN code)
  UMBC: '2378_UMBC.png',    // UMBC
  BRY: '2803_BRY.png',      // Bryant
  NJIT: '2885_NJIT.png',    // NJIT

  // A10 / Big East / AAC additional
  GW: '45_GW.png',          // George Washington
  GMAS: '2244_GMU.png',     // George Mason
  GMU: '2244_GMU.png',      // George Mason (ESPN code)
  LSAL: '2325_LAS.png',     // La Salle
  LAS: '2325_LAS.png',      // La Salle (ESPN code)
  SBU: '179_SBU.png',       // St. Bonaventure
  STBON: '179_SBU.png',     // St. Bonaventure (alias)
  SLU: '139_SLU.png',       // Saint Louis
  STLOU: '139_SLU.png',     // Saint Louis (alias)
  VCU: '2670_VCU.png',      // VCU
  CREIG: '156_CREI.png',    // Creighton
  CREI: '156_CREI.png',     // Creighton (ESPN code)
  DEP: '305_DEP.png',       // DePaul
  DEPAUL: '305_DEP.png',    // DePaul (alias)
  MARQ: '269_MARQ.png',     // Marquette
  PROV: '2507_PROV.png',    // Providence
  HALL: '2550_HALL.png',    // Seton Hall
  SETON: '2550_HALL.png',   // Seton Hall (alias)
  STJN: '2599_SJU.png',     // St. John's
  SJU: '2599_SJU.png',      // St. John's (ESPN code)
  STJS: '2603_JOES.png',    // Saint Joseph's
  JOES: '2603_JOES.png',    // Saint Joseph's (ESPN code)
  XAV: '2752_XAV.png',      // Xavier
  XAVIER: '2752_XAV.png',   // Xavier (alias)
  WICHST: '2724_WICH.png',  // Wichita State
  WICH: '2724_WICH.png',    // Wichita State (ESPN code)
  MEMPH: '235_MEM.png',     // Memphis
  MEM: '235_MEM.png',       // Memphis (ESPN code)
  ECU: '151_ECU.png',       // East Carolina
  TEM: '218_TEM.png',       // Temple
  TLNE: '2655_TULN.png',    // Tulane

  // MAC
  AKR: '2006_AKR.png',      // Akron
  AKRN: '2006_AKR.png',     // Akron (alias)
  BALL: '2050_BALL.png',    // Ball State
  BGSU: '189_BGSU.png',     // Bowling Green
  BUF: '2084_BUF.png',      // Buffalo
  BUFF: '2084_BUF.png',     // Buffalo (alias)
  CMU: '2117_CMU.png',      // Central Michigan
  EMU: '2199_EMU.png',      // Eastern Michigan
  KENT: '2309_KENT.png',    // Kent State
  MIA_OH: '193_M-OH.png',   // Miami (OH)
  'M-OH': '193_M-OH.png',   // Miami (OH) ESPN code
  NIU: '2459_NIU.png',      // Northern Illinois
  OHIO: '195_OHIO.png',     // Ohio
  TOL: '2649_TOL.png',      // Toledo
  WMU: '2711_WMU.png',      // Western Michigan

  // Sun Belt / CUSA / Independent
  APP: '2026_APP.png',      // Appalachian State
  CCU: '324_CCU.png',       // Coastal Carolina
  GASO: '290_GASO.png',     // Georgia Southern
  GAST: '2247_GAST.png',    // Georgia State
  GSU: '2247_GAST.png',     // Georgia State (alias)
  JMU: '256_JMU.png',       // James Madison
  LT: '2348_LT.png',        // Louisiana Tech
  ARST: '2032_ARST.png',    // Arkansas State
  ULM: '2433_ULM.png',      // UL Monroe
  ULL: '309_UL.png',        // Louisiana
  UL: '309_UL.png',         // Louisiana (ESPN code)
  TXST: '326_TXST.png',     // Texas State
  CHAR: '2429_CLT.png',     // Charlotte
  CLT: '2429_CLT.png',      // Charlotte (ESPN code)
  FAU: '2226_FAU.png',      // FAU
  FIU: '2229_FIU.png',      // FIU
  MTSU: '2393_MTSU.png',    // Middle Tennessee
  WKU: '98_WKU.png',        // Western Kentucky
  ODU: '295_ODU.png',       // Old Dominion
  NMSU: '166_NMSU.png',     // New Mexico State
  NM: '167_UNM.png',        // New Mexico
  UNM: '167_UNM.png',       // New Mexico (ESPN code)
  USA: '6_USA.png',         // South Alabama
  SOAL: '6_USA.png',        // South Alabama (alias)
  LR: '2031_LR.png',        // Little Rock
  USM: '2572_USM.png',      // Southern Miss
  SOMI: '2572_USM.png',     // Southern Miss (alias)
  UTEP: '2638_UTEP.png',    // UTEP
  UTSA: '2636_UTSA.png',    // UTSA
  UNT: '249_UNT.png',       // North Texas
  JAX: '294_JAX.png',       // Jacksonville
  LIB: '2335_LIB.png',      // Liberty
  KENN: '338_KENN.png',     // Kennesaw State
  UNF: '2454_UNF.png',      // North Florida
  STET: '56_STET.png',      // Stetson

  // MWC
  AF: '2005_AF.png',        // Air Force
  AFA: '2005_AF.png',       // Air Force (alias)
  BSU: '68_BOIS.png',       // Boise State
  BOIS: '68_BOIS.png',      // Boise State (ESPN code)
  CSU: '36_CSU.png',        // Colorado State
  FRES: '278_FRES.png',     // Fresno State
  NEV: '2440_NEV.png',      // Nevada
  UNLV: '2439_UNLV.png',    // UNLV
  USU: '328_USU.png',       // Utah State
  WYO: '2751_WYO.png',      // Wyoming
  SJSU: '23_SJSU.png',      // San Jose State

  // Ivy League
  BRWN: '225_BRWN.png',     // Brown
  BROWN: '225_BRWN.png',    // Brown (alias)
  COLU: '171_COLU.png',     // Columbia
  COR: '172_COR.png',       // Cornell
  DART: '159_DART.png',     // Dartmouth
  HARV: '108_HARV.png',     // Harvard
  PENN: '219_PENN.png',     // Penn
  PRIN: '163_PRIN.png',     // Princeton
  YALE: '43_YALE.png',      // Yale

  // Additional misc ESPN teams
  LEM: '2330_LEM.png',      // Le Moyne
  EVAN: '339_EVAN.png',     // Evansville
  EVNS: '339_EVAN.png',     // Evansville (alias)
  EIU: '2197_EIU.png',      // Eastern Illinois
  SIU: '79_SIU.png',        // Southern Illinois
  SIUE: '2565_SIUE.png',    // SIU Edwardsville
  WIU: '2710_WIU.png',      // Western Illinois
  BRAD: '71_BRAD.png',      // Bradley
  LOYCHI: '2350_LUC.png',   // Loyola Chicago
  LUC: '2350_LUC.png',      // Loyola Chicago (ESPN code)
  LOYM: '2352_L-MD.png',    // Loyola Maryland
  'L-MD': '2352_L-MD.png',  // Loyola Maryland (ESPN code)
  UIC: '82_UIC.png',        // UIC
  VAL: '2674_VAL.png',      // Valparaiso (ESPN code)
  MOST: '2623_MOST.png',    // Missouri State (ESPN code)
  SFPA: '2598_SFPA.png',    // St. Francis PA (ESPN code)
  MSM: '116_MSM.png',       // Mount St. Mary's
  MTSTM: '116_MSM.png',     // Mount St. Mary's (alias)
  RMU: '2523_RMU.png',      // Robert Morris
  DAV: '2166_DAV.png',      // Davidson
  FGCU: '526_FGCU.png',     // Florida Gulf Coast
  UNCA: '2427_UNCA.png',    // UNC Asheville
  MONM: '2405_MONM.png',    // Monmouth
  WGA: '2698_WGA.png',      // West Georgia
  UWG: '2698_WGA.png',      // West Georgia (alias)
  BELMT: '91_BELL.png',     // Belmont
  STMN: '2900_STMN.png',    // St. Thomas MN
  CP: '13_CP.png',          // Cal Poly
  CPOLY: '13_CP.png',       // Cal Poly (alias)
  AMCC: '357_AMCC.png',     // Texas A&M Commerce

  // Additional aliases and missing teams (2025-12-15)
  UCON: '41_CONN.png',      // UConn (receiver alias) - VERIFIED
  UCONN: '41_CONN.png',     // UConn (alternate) - VERIFIED
  SC: '2579_SC.png',        // South Carolina (ESPN code)

  // D2/D1 transitional schools with downloaded logos
  USI: 'southernIndiana.png',     // Southern Indiana Screaming Eagles - VERIFIED (D1 2024)
  CBVU: 'campbellsville.webp'     // Campbellsville Tigers - VERIFIED (NAIA)

  // NOTE: These NAIA/D2 schools don't have downloadable logos:
  // BRTN (Bryan TN), ECCL (Ecclesia), MNCR (Minnesota Crookston), EAWE (East-West)
  // They will show no logo in dashboard
}

// CFB uses school names - simplified mapping for FBS
export const CFB_LOGOS = {
  ALA: 'Alabama.png', AUB: 'Auburn.png', UGA: 'Georgia.png', LSU: 'LSU.png',
  TENN: 'Tennessee.png', FLA: 'Florida.png', TAMU: 'Texas_A&M.png', MISS: 'Ole_Miss.png',
  MSST: 'Mississippi_State.png', ARK: 'Arkansas.png', MIZZ: 'Missouri.png', VAN: 'Vanderbilt.png',
  UK: 'Kentucky.png', SCAR: 'South_Carolina.png', OSU: 'Ohio_State.png', MICH: 'Michigan.png',
  PSU: 'Penn_State.png', MSU: 'Michigan_State.png', WIS: 'Wisconsin.png', IOWA: 'Iowa.png',
  NEB: 'Nebraska.png', NW: 'Northwestern.png', NU: 'Northwestern.png', MINN: 'Minnesota.png', ILL: 'Illinois.png',
  IND: 'Indiana.png', PUR: 'Purdue.png', RUT: 'Rutgers.png', MD: 'Maryland.png',
  TEX: 'Texas.png', OU: 'Oklahoma.png', OKST: 'Oklahoma_State.png', BAY: 'Baylor.png',
  TCU: 'TCU.png', TTU: 'Texas_Tech.png', KSU: 'Kansas_State.png', KU: 'Kansas.png',
  ISU: 'Iowa_State.png', WVU: 'West_Virginia.png', CIN: 'Cincinnati.png', UCF: 'UCF.png',
  HOU: 'Houston.png', BYU: 'BYU.png', ARIZ: 'Arizona.png', ASU: 'Arizona_State.png',
  COLO: 'Colorado.png', UTAH: 'Utah.png', USC: 'USC.png', UCLA: 'UCLA.png',
  ORE: 'Oregon.png', ORST: 'Oregon_State.png', WASH: 'Washington.png', WSU: 'Washington_State.png',
  CAL: 'California.png', STAN: 'Stanford.png', CLEM: 'Clemson.png', FSU: 'Florida_State.png',
  MIA: 'Miami.png', VT: 'Virginia_Tech.png', UVA: 'Virginia.png', UNC: 'North_Carolina.png',
  NCST: 'NC_State.png', DUKE: 'Duke.png', WAKE: 'Wake_Forest.png', BC: 'Boston_College.png',
  LOU: 'Louisville.png', PITT: 'Pittsburgh.png', SYR: 'Syracuse.png', GT: 'Georgia_Tech.png',
  ND: 'Notre_Dame.png', BSU: 'Boise_State.png', SDSU: 'San_Diego_State.png', FRES: 'Fresno_State.png',
  UNLV: 'UNLV.png', NEV: 'Nevada.png', CSU: 'Colorado_State.png', WYO: 'Wyoming.png',
  USU: 'Utah_State.png', HAW: 'Hawaii.png', SJSU: 'San_Jose_State.png', AF: 'Air_Force.png', AFA: 'Air_Force.png',
  NM: 'New_Mexico.png', CMU: 'Central_Michigan.png', SMU: 'SMU.png', MEM: 'Memphis.png', TUL: 'Tulane.png',
  TLSA: 'Tulsa.png', USF: 'USF.png', ECU: 'East_Carolina.png', TEM: 'Temple.png',
  NAVY: 'Navy.png', CHAR: 'Charlotte.png', FAU: 'FAU.png', UAB: 'UAB.png',
  RICE: 'Rice.png', UTSA: 'UTSA.png', UNT: 'North_Texas.png', ARMY: 'Army.png',
  UMASS: 'UMass.png', CONN: 'UConn.png', UCON: 'UConn.png', JVST: 'Jacksonville_State.png', SHSU: 'Sam_Houston.png',
  // ESPN abbreviation aliases (differ from standard codes)
  FIU: 'FIU.png',                    // Florida International
  'M-OH': 'Miami_OH.png',            // Miami (OH) - ESPN uses M-OH
  MIA_OH: 'Miami_OH.png',            // Miami (OH) alternate
  BOIS: 'Boise_State.png',           // Boise State - ESPN uses BOIS
  IU: 'Indiana.png',                 // Indiana - ESPN uses IU
  MIZ: 'Missouri.png',               // Missouri - ESPN uses MIZ
  NCSU: 'NC_State.png',              // NC State - ESPN uses NCSU
  TULN: 'Tulane.png',                // Tulane - ESPN uses TULN
  UL: 'Louisiana.png',               // Louisiana - ESPN uses UL
  USM: 'Southern_Miss.png',          // Southern Miss - ESPN uses USM
  WKU: 'Western_Kentucky.png',       // Western Kentucky
  ARST: 'Arkansas_State.png',        // Arkansas State
  GASO: 'Georgia_Southern.png',      // Georgia Southern
  ODU: 'Old_Dominion.png',           // Old Dominion
  TXST: 'Texas_State.png',           // Texas State
  LT: 'Louisiana_Tech.png',          // Louisiana Tech
  TOL: 'Toledo.png',                 // Toledo
  WMU: 'Western_Michigan.png',       // Western Michigan
  EMU: 'Eastern_Michigan.png',       // Eastern Michigan
  NIU: 'Northern_Illinois.png',      // Northern Illinois
  BGSU: 'Bowling_Green.png',         // Bowling Green
  AKRN: 'Akron.png',                 // Akron
  KENT: 'Kent_State.png',            // Kent State
  BALL: 'Ball_State.png',            // Ball State
  BUFF: 'Buffalo.png',               // Buffalo
  CCU: 'Coastal_Carolina.png',       // Coastal Carolina
  JMU: 'James_Madison.png',          // James Madison
  APP: 'Appalachian_State.png',       // Appalachian State
  TROY: 'Troy.png'                   // Troy
}

export const LEAGUE_LOGOS = {
  NFL: '/logos/leagues/NFL.svg',
  NBA: '/logos/leagues/NBA.png',
  NHL: '/logos/leagues/NHL.png',
  MLB: '/logos/leagues/MLB.png',
  CFB: '/logos/leagues/NFL.svg',  // Use NFL as fallback for now
  CBB: '/logos/leagues/NBA.png'   // Use NBA as fallback for now
}

export const BOOK_LOGOS = {
  // Local logo files
  draftkings: '/logos/books/draftkings.png',
  fanduel: '/logos/books/fanduel.ico',
  betmgm: '/logos/books/betmgm.ico',
  betrivers: '/logos/books/betrivers.png',
  bovada: '/logos/books/bovada.png',
  ballybet: '/logos/books/ballybet.png',
  betonline: '/logos/books/betonline.png',
  caesars: '/logos/books/caesars.png',
  fanatics: '/logos/books/fanatics.svg',
  fliff: '/logos/books/fliff.svg',
  hardrock: '/logos/books/hardrock.svg',
  hardrockbet: '/logos/books/hardrock.svg',
  mybookie: '/logos/books/mybookie.png',
  pinnacle: 'https://www.google.com/s2/favicons?domain=pinnacle.com&sz=32',
  kalshi: '/logos/books/kalshi.png',
  polymarket: '/logos/books/polymarket.png',
  thescore: '/logos/books/thescore.svg',
  pointsbet: '/logos/books/pointsbet.svg',
  unibet: '/logos/books/unibet.svg',
}

// Domain mapping for bookmakers without local logos → Google favicon CDN
const BOOK_DOMAINS = {
  betus: 'betus.com.pa',
  lowvig: 'lowvig.ag',
  coral: 'coral.co.uk',
  ladbrokes: 'ladbrokes.com',
  nordicbet: 'nordicbet.com',
  betsson: 'betsson.com',
  betsafe: 'betsafe.com',
  neds: 'neds.com.au',
  tipico: 'tipico.de',
  winamax: 'winamax.fr',
  parionssport: 'enligne.parionssport.fdj.fr',
  pmu: 'parisportif.pmu.fr',
  '888sport': '888sport.com',
  betr: 'betr.com.au',
  pinnacle: 'pinnacle.com',
  fanatics: 'fanaticsbook.com',
  fliff: 'fliff.com',
  ballybet: 'ballybet.com',
  williamhill: 'williamhill.com',
  '1xbet': '1xbet.com',
  coolbet: 'coolbet.com',
  smarkets: 'smarkets.com',
  tab: 'tab.com.au',
  sportsbet: 'sportsbet.com.au',
  paddypower: 'paddypower.com',
  espnbet: 'espnbet.com',
  betparx: 'betparx.com',
  atg: 'atg.se',
  svenskaspel: 'svenskaspel.se',
  virginbet: 'virginbet.com',
  livescorebet: 'livescorebet.com',
  leovegas: 'leovegas.com',
  grosvenor: 'grosvenorsport.com',
  casumo: 'casumo.com',
  tabtouch: 'tabtouch.com.au',
  netbet: 'netbet.fr',
  playup: 'playup.com',
  betright: 'betright.com.au',
  gtbets: 'gtbets.eu',
  betanything: 'betanything.eu',
  betanysports: 'betanysports.eu',
  betway: 'betway.com',
  boylesports: 'boylesports.com',
  betvictor: 'betvictor.com',
  marathonbet: 'marathonbet.com',
  everygame: 'everygame.eu',
  superbook: 'superbook.com',
  tipico_us: 'tipico.com',
  betfair: 'betfair.com',
  betfred: 'betfred.com',
  bet365: 'bet365.com',
  foxbet: 'foxbet.com',
  wynnbet: 'wynnbet.com',
  twinspires: 'twinspires.com',
  sisportsbook: 'sisportsbook.com',
  sugarhouse: 'playsugarhouse.com',
  barstool: 'barstoolsportsbook.com',
  windcreek: 'windcreek.com',
  betfred_us: 'betfred.com',
  mrgreen: 'mrgreen.com',
  betclic: 'betclic.fr',
  sport888: '888sport.com',
  matchbook: 'matchbook.com',
  novig: 'novig.us',
  betopenly: 'betopenly.com',
  prophetx: 'prophetx.co',
  rebet: 'rebet.app',
  sporttrade: 'getsporttrade.com',
  prizepicks: 'prizepicks.com',
  underdog: 'underdogfantasy.com',
  pick6: 'pick6.draftkings.com',
  betfair_ex_uk: 'betfair.com',
  betfair_sb_uk: 'betfair.com',
  betfair_ex_au: 'betfair.com.au',
  pointsbetus: 'pointsbet.com',
  pointsbetau: 'pointsbet.com.au',
  unibetuk: 'unibet.co.uk',
  unibetse: 'unibet.se',
  unibetni: 'unibet.co.uk',
  unibeteu: 'unibet.eu',
  unibetau: 'unibet.com.au',
  laaborokesau: 'ladbrokes.com.au',
  ladbrokesuk: 'ladbrokes.com',
  williamhill_us: 'williamhill.com',
}

// ESPN team ID mapping for CBB teams without local logos
// These are ESPN's internal team IDs used in their CDN URLs
const ESPN_CBB_TEAM_IDS = {
  // Common teams that might be missing from static logos
  'UMES': 2379,  // Maryland Eastern Shore
  'STJS': 2603,  // St. Joseph's
  'UTRGV': 292,  // UT Rio Grande Valley
  'UTA': 254,    // UT Arlington
  'TARL': 2455,  // Tarleton State
  'SFA': 2617,   // Stephen F. Austin
  'ACU': 2000,   // Abilene Christian
  'GRAM': 2755,  // Grambling State
  'PRVU': 2504,  // Prairie View A&M
  'TXSO': 2640,  // Texas Southern
  'ALCO': 2006,  // Alcorn State
  'MVST': 2400,  // Mississippi Valley State
  'JKST': 96,    // Jackson State
  'AAMU': 2010,  // Alabama A&M
  'ALST': 2011,  // Alabama State
  'ARK_PB': 2029, // Arkansas Pine Bluff
  'SOUT': 2582,  // Southern University
  'BCOOK': 2065, // Bethune-Cookman
  'FAMU': 50,    // Florida A&M
  'SCST': 2569,  // South Carolina State
  'NCAT': 2448,  // NC A&T
  'NCCEN': 2428, // NC Central
  'DELST': 2169, // Delaware State
  'MORG': 2415,  // Morgan State
  'COPP': 2154,  // Coppin State
  'HOW': 47,     // Howard
  'NORF': 2450,  // Norfolk State
  'HAMP': 2272,  // Hampton
}

// Helper function to get team logo path
export const getTeamLogo = (canonical, league) => {
  const leagueLower = league?.toLowerCase() || 'nfl'
  let logoMap
  let logoPath // Different leagues may use different paths

  switch (leagueLower) {
    case 'nfl':
      logoMap = NFL_LOGOS
      logoPath = '/logos/teams/nfl'
      break
    case 'nba':
      logoMap = NBA_LOGOS
      logoPath = '/logos/teams/nba'
      break
    case 'nhl':
      logoMap = NHL_LOGOS
      logoPath = '/logos/teams/nhl'
      break
    case 'mlb':
      logoMap = MLB_LOGOS
      logoPath = '/logos/teams/mlb'
      break
    case 'cfb':
    case 'ncaaf':
      logoMap = CFB_LOGOS
      logoPath = '/logos/teams/cfb'
      break
    case 'cbb':
    case 'ncaab':
    case 'ncaam':
    case 'ncaaw':
      logoMap = CBB_LOGOS
      logoPath = '/logos/teams/ncaa' // NCAA logos folder
      break
    default:
      logoMap = NFL_LOGOS
      logoPath = '/logos/teams/nfl'
  }

  const resolvedCanonical = resolveCanonicalTeamCode(canonical, leagueLower)
  const filename = logoMap[canonical] || logoMap[resolvedCanonical]
  if (filename) {
    return `${logoPath}/${encodeURIComponent(filename)}`
  }

  // Fallback: For CBB teams not in static map, try ESPN CDN
  if (leagueLower === 'cbb' || leagueLower === 'ncaab' || leagueLower === 'ncaam' || leagueLower === 'ncaaw') {
    const espnId = ESPN_CBB_TEAM_IDS[canonical] || ESPN_CBB_TEAM_IDS[resolvedCanonical]
    if (espnId) {
      return `https://a.espncdn.com/i/teamlogos/ncaa/500/${espnId}.png`
    }
  }

  return null
}

// Helper to get bookmaker logo — checks local files first, then favicon CDN
export const getBookLogo = (bookmaker) => {
  if (!bookmaker) return null
  // Normalize: lowercase, remove spaces, parentheses, and common suffixes
  const key = bookmaker.toLowerCase()
    .replace(/\s*\(.*?\)\s*/g, '') // remove parenthetical like "(Lay)"
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9_]/g, '')

  // Check local logos first
  if (BOOK_LOGOS[key]) return BOOK_LOGOS[key]

  // Try common alias variations
  const aliases = {
    'hardrockbet': 'hardrock',
    'hardrocksportsbook': 'hardrock',
    'hardrockbetaz': 'hardrock',
    'espnbet': 'espnbet',
    'williamhill_us': 'williamhill',
    'pointsbet_us': 'pointsbet',
    'pointsbetus': 'pointsbet',
    'pointsbetau': 'pointsbet',
    'fanaticssportsbook': 'fanatics',
    'fanaticssb': 'fanatics',
    'fanaticabet': 'fanatics',
    'fanaticssportsbetting': 'fanatics',
    'fliffsportsbook': 'fliff',
    'fliffsocial': 'fliff',
    'fliffapp': 'fliff',
    'fliffsports': 'fliff',
    'pinnaclesports': 'pinnacle',
    'pinnaclesportsbook': 'pinnacle',
      'unibetuk': 'unibet',
      'unibetse': 'unibet',
      'unibetni': 'unibet',
      'unibeteu': 'unibet',
      'unibetau': 'unibet',
      'unibetfr': 'unibet',
      'leovegasse': 'leovegas',
    'ladbrokes_au': 'ladbrokes',
    'ladbrokesau': 'ladbrokes',
    'ladbrokesuk': 'ladbrokes',
    'tipico_de': 'tipico',
    'tipicous': 'tipico',
    'winamaxde': 'winamax',
    'winamaxfr': 'winamax',
    'parionssportfr': 'parionssport',
    'smarketslaymarket': 'smarkets',
    'smarketslay': 'smarkets',
    'betfairexuk': 'betfair',
    'betfairsbuk': 'betfair',
    'betfairexau': 'betfair',
    'draftkingspick6': 'pick6',
    'pick6draftkings': 'pick6',
    'betrpicks': 'betr',
    '888sport': 'sport888',
    'betrus': 'betr',
    'betrau': 'betr',
  }
  const aliased = aliases[key] || key
  if (BOOK_LOGOS[aliased]) return BOOK_LOGOS[aliased]

  // Fallback: Google favicon CDN
  const domain = BOOK_DOMAINS[key] || BOOK_DOMAINS[aliased]
  if (domain) {
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=32`
  }

  return null
}

export const BOOK_BRAND_COLORS = {
  draftkings: '#53d769',
  pick6: '#f97316',
  fanduel: '#1493ff',
  betmgm: '#c4a962',
  caesars: '#046a38',
  espnbet: '#f5f5f5',
  thescore: '#e02020',
  fanatics: '#ed174c',
  betrivers: '#0f4fa8',
  ballybet: '#d71920',
  betsafe: '#e31c24',
  nordicbet: '#00a6ff',
  hardrock: '#c89b3c',
  fliff: '#d5ff3f',
  bovada: '#e53935',
  betonline: '#f97316',
  betanything: '#00b8d4',
  betr: '#ff6b00',
  betsson: '#00c1d4',
  playup: '#ff3b30',
  coral: '#008bd0',
  ladbrokes: '#e10600',
  grosvenor: '#9b1c31',
  betparx: '#fdb515',
  atg: '#e30613',
  svenskaspel: '#ffcd00',
  livescorebet: '#ff6f00',
  virginbet: '#d71440',
  tabtouch: '#0072ce',
  netbet: '#f9c80e',
  unibet: '#00a651',
  betway: '#ffd54f',
  winamax: '#ff1744',
  mybookie: '#f57c00',
  everygame: '#42a5f5',
  pmu: '#0b8f4d',
  marathonbet: '#0094d9',
  pinnacle: '#ff9800',
  kalshi: '#ff8f00',
  polymarket: '#4f8cff',
  prizepicks: '#ff7a00',
  underdog: '#ff6f00',
  betopenly: '#7c4dff',
  matchbook: '#ef6c00',
  novig: '#00c853',
  prophetx: '#26c6da',
  rebet: '#ff4081',
  smarkets: '#ff4081',
  sporttrade: '#1e88e5',
  default: '#00B8D4',
}

export function getBookBrandColor(bookmaker) {
  const key = compactLookupKey(bookmaker)
  const aliases = {
    hardrockbet: 'hardrock',
    hardrocksportsbook: 'hardrock',
    pointsbetus: 'pointsbet',
    pointsbetau: 'pointsbet',
    unibetuk: 'unibet',
    unibetse: 'unibet',
    unibetni: 'unibet',
    unibeteu: 'unibet',
    unibetau: 'unibet',
    unibetfr: 'unibet',
    draftkingspick6: 'pick6',
    pick6draftkings: 'pick6',
    betrus: 'betr',
    betrau: 'betr',
    betrpicks: 'betr',
    espnbet: 'espnbet',
    atgse: 'atg',
    svenskaspelse: 'svenskaspel',
    livescorebetuk: 'livescorebet',
    virginbetuk: 'virginbet',
  }
  const aliased = aliases[key] || key
  return BOOK_BRAND_COLORS[aliased] || BOOK_BRAND_COLORS.default
}

// Team display names by league - enables proper lookup by league
export const NFL_TEAM_NAMES = {
  ARI: 'Arizona Cardinals', ATL: 'Atlanta Falcons', BAL: 'Baltimore Ravens', BUF: 'Buffalo Bills',
  CAR: 'Carolina Panthers', CHI: 'Chicago Bears', CIN: 'Cincinnati Bengals', CLE: 'Cleveland Browns',
  DAL: 'Dallas Cowboys', DEN: 'Denver Broncos', DET: 'Detroit Lions', GB: 'Green Bay Packers',
  HOU: 'Houston Texans', IND: 'Indianapolis Colts', JAX: 'Jacksonville Jaguars', KC: 'Kansas City Chiefs',
  LAC: 'LA Chargers', LAR: 'LA Rams', LV: 'Las Vegas Raiders', MIA: 'Miami Dolphins',
  MIN: 'Minnesota Vikings', NE: 'New England Patriots', NO: 'New Orleans Saints', NYG: 'NY Giants',
  NYJ: 'NY Jets', PHI: 'Philadelphia Eagles', PIT: 'Pittsburgh Steelers', SEA: 'Seattle Seahawks',
  SF: 'San Francisco 49ers', TB: 'Tampa Bay Buccaneers', TEN: 'Tennessee Titans', WAS: 'Washington Commanders', WSH: 'Washington Commanders'
}

export const NBA_TEAM_NAMES = {
  ATL: 'Atlanta Hawks', BOS: 'Boston Celtics', BKN: 'Brooklyn Nets', CHA: 'Charlotte Hornets',
  CHI: 'Chicago Bulls', CLE: 'Cleveland Cavaliers', DAL: 'Dallas Mavericks', DEN: 'Denver Nuggets',
  DET: 'Detroit Pistons', GSW: 'Golden State Warriors', GS: 'Golden State Warriors', HOU: 'Houston Rockets', IND: 'Indiana Pacers',
  LAC: 'LA Clippers', LAL: 'LA Lakers', MEM: 'Memphis Grizzlies', MIA: 'Miami Heat',
  MIL: 'Milwaukee Bucks', MIN: 'Minnesota Timberwolves', NOP: 'New Orleans Pelicans', NO: 'New Orleans Pelicans',
  NYK: 'NY Knicks', NY: 'NY Knicks',  // NY alias for ESPN
  OKC: 'Oklahoma City Thunder', ORL: 'Orlando Magic', PHI: 'Philadelphia 76ers', PHX: 'Phoenix Suns', PHO: 'Phoenix Suns',
  POR: 'Portland Trail Blazers', SAC: 'Sacramento Kings', SAS: 'San Antonio Spurs', SA: 'San Antonio Spurs',  // SA alias
  TOR: 'Toronto Raptors', UTA: 'Utah Jazz', UTAH: 'Utah Jazz', WAS: 'Washington Wizards', WSH: 'Washington Wizards'
}

export const NHL_TEAM_NAMES = {
  ANA: 'Anaheim Ducks', ARI: 'Arizona Coyotes', BOS: 'Boston Bruins', BUF: 'Buffalo Sabres',
  CAR: 'Carolina Hurricanes', CBJ: 'Columbus Blue Jackets', CGY: 'Calgary Flames', CHI: 'Chicago Blackhawks',
  COL: 'Colorado Avalanche', DAL: 'Dallas Stars', DET: 'Detroit Red Wings', EDM: 'Edmonton Oilers',
  FLA: 'Florida Panthers', LA: 'LA Kings', LAK: 'LA Kings', MIN: 'Minnesota Wild', MTL: 'Montreal Canadiens',
  NJ: 'New Jersey Devils', NJD: 'New Jersey Devils', NSH: 'Nashville Predators', NYI: 'NY Islanders', NYR: 'NY Rangers',
  OTT: 'Ottawa Senators', PHI: 'Philadelphia Flyers', PIT: 'Pittsburgh Penguins', SEA: 'Seattle Kraken',
  SJS: 'San Jose Sharks', STL: 'St. Louis Blues', TB: 'Tampa Bay Lightning', TBL: 'Tampa Bay Lightning', TOR: 'Toronto Maple Leafs',
  UTA: 'Utah Mammoth',  // Utah Mammoth (2025-12-17)
  VAN: 'Vancouver Canucks', VGK: 'Vegas Golden Knights', WPG: 'Winnipeg Jets', WSH: 'Washington Capitals'
}

export const MLB_TEAM_NAMES = {
  ARI: 'Arizona Diamondbacks', ATL: 'Atlanta Braves', BAL: 'Baltimore Orioles', BOS: 'Boston Red Sox',
  CHC: 'Chicago Cubs', CHW: 'Chicago White Sox', CWS: 'Chicago White Sox', CIN: 'Cincinnati Reds', CLE: 'Cleveland Guardians',
  COL: 'Colorado Rockies', DET: 'Detroit Tigers', HOU: 'Houston Astros', KCR: 'Kansas City Royals',
  LAA: 'LA Angels', LAD: 'LA Dodgers', MIA: 'Miami Marlins', MIL: 'Milwaukee Brewers',
  MIN: 'Minnesota Twins', NYM: 'NY Mets', NYY: 'NY Yankees', OAK: 'Oakland Athletics',
  PHI: 'Philadelphia Phillies', PIT: 'Pittsburgh Pirates', SDP: 'San Diego Padres', SEA: 'Seattle Mariners',
  SFG: 'San Francisco Giants', STL: 'St. Louis Cardinals', TBR: 'Tampa Bay Rays', TEX: 'Texas Rangers',
  TOR: 'Toronto Blue Jays', WSH: 'Washington Nationals'
}

// CBB Team Names - Generated from receiver config + ESPN mappings (2025-12-15)
export const CBB_TEAM_NAMES = {
  ACU: 'Abilene Christian', ALB: 'Albany', AME: 'American', ARMY: 'Army', BALL: 'Ball State',
  BELL: 'Bellarmine', BELMT: 'Belmont', BING: 'Binghamton', BRAD: 'Bradley', BROWN: 'Brown',
  BRTN: 'Bryan Lions', BRY: 'Bryant', BU: 'Boston University', BUCK: 'Bucknell', BUTLER: 'Butler',
  CBVU: 'Campbellsville Tigers',
  CAL: 'California', CALB: 'California Baptist', CAMP: 'Campbell', CAN: 'Canisius',
  CCSU: 'Central Connecticut State', CHAR: 'Charlotte', CHAT: 'Chattanooga', CIT: 'The Citadel',
  CLST: 'Cleveland State', COFC: 'College of Charleston', COLG: 'Colgate', COPP: 'Coppin State',
  CREIG: 'Creighton', CSBAK: 'Cal State Bakersfield', DART: 'Dartmouth', DAV: 'Davidson',
  DAVIS: 'UC Davis', DAYT: 'Dayton', DEL: 'Delaware', DEPAUL: 'DePaul', DETM: 'Detroit Mercy',
  DRAKE: 'Drake', DREX: 'Drexel', DSU: 'Delaware State', DUQU: 'Duquesne', EAWE: 'East-West Phantoms',
  ECCL: 'Ecclesia Royals', ECU: 'East Carolina',
  EIU: 'Eastern Illinois', ELON: 'Elon', ETAM: 'East Texas A&M Lions', ETSU: 'East Tennessee State', EVNS: 'Evansville',
  EWASH: 'Eastern Washington', FAIR: 'Fairfield', FDU: 'Fairleigh Dickinson', FORD: 'Fordham',
  FUR: 'Furman', GCU: 'Grand Canyon', GMAS: 'George Mason', GMU: 'George Mason', GONZ: 'Gonzaga',
  GTOWN: 'Georgetown', GW: 'George Washington', GWEB: 'Gardner-Webb', GWU: 'Gardner-Webb',
  HART: 'Hartford', HARV: 'Harvard', HC: 'Holy Cross', HCU: 'Houston Christian', HOF: 'Hofstra',
  HOU: 'Houston',
  HOUST: 'Houston Christian', HPU: 'High Point', IDAHO: 'Idaho', INST: 'Indiana State', IONA: 'Iona',
  ISIL: 'Illinois State', IUIND: 'IU Indianapolis', JAX: 'Jacksonville', JMU: 'James Madison',
  LAF: 'Lafayette', LEH: 'Lehigh', LIU: 'Long Island', LMCHI: 'Loyola Marymount', LONG: 'Longwood',
  LOYCHI: 'Loyola Chicago', LOYM: 'Loyola Maryland', LSAL: 'La Salle', MANH: 'Manhattan',
  MARIS: 'Marist', MARQ: 'Marquette', MCN: 'McNeese', ME: 'Maine', MERC: 'Mercer', MERR: 'Merrimack',
  MIST: 'Missouri State', MNCR: 'Minnesota Crookston Golden Eagles', MONM: 'Monmouth', MORE: 'Morehead State', MTSTM: "Mount St. Mary's",
  MCNSE: 'McNeese Cowboys', MURR: 'Murray State', NAVY: 'Navy', NE: 'Northeastern', NHAV: 'New Haven', NIA: 'Niagara',
  NIAG: 'Niagara', NIOWA: 'Northern Iowa', NKU: 'Northern Kentucky', NOVA: 'Villanova',
  NSU: 'Norfolk State', OAK: 'Oakland', PACIFIC: 'Pacific', PEPP: 'Pepperdine', PFW: 'Purdue Fort Wayne',
  PORT: 'Portland', PRES: 'Presbyterian', PRIN: 'Princeton', PROV: 'Providence', PRTST: 'Portland State',
  QUINN: 'Quinnipiac', RAD: 'Radford', RHO: 'Rhode Island Rams', RICH: 'Richmond', RID: 'Rider', RMU: 'Robert Morris',
  SAM: 'Samford', SAMF: 'Samford', SANFR: 'San Francisco', SANTA: 'Santa Clara', SDIEGO: 'San Diego',
  SDST: 'South Dakota State', SELA: 'SE Louisiana Lions', SEMO: 'Southeast Missouri State', SETON: 'Seton Hall', SHU: 'Sacred Heart',
  SIEN: 'Siena', SIUE: 'SIU Edwardsville', 'SIU-Edwardsville': 'SIU Edwardsville', STBON: 'Saint Bonaventure', STET: 'Stetson',
  STFB: 'St. Francis (BKN)', STFPA: 'Saint Francis (PA)', STJN: "St. John's", STJS: "Saint Joseph's",
  STLOU: 'Saint Louis', STMRY: "Saint Mary's", STON: 'Stony Brook', STPT: "Saint Peter's",
  TARL: 'Tarleton State', TOW: 'Towson', TROY: 'Troy', TTU: 'Tennessee Tech', UCIRVN: 'UC Irvine',
  UCON: 'UConn Huskies', UCONN: 'UConn Huskies',
  UCRIV: 'UC Riverside', UCSB: 'UC Santa Barbara', UCSD: 'UC San Diego', UIW: 'Incarnate Word Cardinals',
  UMASS: 'Massachusetts', UMBC: 'Maryland Baltimore County', UMES: 'Maryland Eastern Shore',
  UNCA: 'UNC Asheville', UNCG: 'UNC Greensboro', UNCW: 'UNC Wilmington', UNH: 'New Hampshire',
  UPST: 'USC Upstate', URI: 'Rhode Island', USI: 'Southern Indiana Screaming Eagles', UTTCH: 'Utah Tech', UTUV: 'Utah Valley', UVM: 'Vermont',
  UWG: 'West Georgia', VALS: 'Valparaiso', VCU: 'Virginia Commonwealth', VMI: 'Virginia Military',
  WAG: 'Wagner', WCU: 'Western Carolina', WICHST: 'Wichita State', WINT: 'Winthrop',
  WM: 'William and Mary', WOF: 'Wofford', WYO: 'Wyoming', XAVIER: 'Xavier', YSU: 'Youngstown State',
  // Added 2025-12-17: Missing teams
  APP: 'Appalachian State',
  CCU: 'Coastal Carolina',
  CHSO: 'Charleston Southern',
  GASO: 'Georgia Southern',
  GRAM: 'Grambling State',
  GSU: 'Georgia State',
  HAMP: 'Hampton',
  ILST: 'Illinois State',
  JKST: 'Jackson State',
  LBSU: 'Long Beach State',
  LIND: 'Lindenwood',
  NAU: 'Northern Arizona',
  OKST: 'Oklahoma State',
  ORU: 'Oral Roberts',
  SIU: 'Southern Illinois',
  SOMI: 'Southeast Missouri',
  SUU: 'Southern Utah',
  TCU: 'TCU',
  TEM: 'Temple',
  TNST: 'Tennessee State',
  UALR: 'Little Rock',
  UGA: 'Georgia',
  ULL: 'Louisiana',
  UMKC: 'Kansas City',
  UND: 'North Dakota',
  UNF: 'North Florida',
  UTM: 'UT Martin',
  WIU: 'Western Illinois',
  Yale: 'Yale'
}

// CFB Team Names - Generated from receiver config (2025-12-15)
export const CFB_TEAM_NAMES = {
  AFA: 'Air Force', AKR: 'Akron', ALA: 'Alabama', APP: 'Appalachian State', ARIZ: 'Arizona',
  ARK: 'Arkansas', ARMY: 'Army', ARST: 'Arkansas State', ASU: 'Arizona State', AUB: 'Auburn',
  BALL: 'Ball State', BAY: 'Baylor', BC: 'Boston College', BGSU: 'Bowling Green', BSU: 'Boise State',
  BUFF: 'Buffalo', BYU: 'BYU', CAL: 'California', CCU: 'Coastal Carolina', CHAR: 'Charlotte',
  CIN: 'Cincinnati', CLEM: 'Clemson', CMU: 'Central Michigan', COL: 'Colorado', COLO: 'Colorado State',
  DUKE: 'Duke', ECU: 'East Carolina', EMU: 'Eastern Michigan', FAU: 'Florida Atlantic',
  FIU: 'Florida International', FLA: 'Florida', FRES: 'Fresno State', FSU: 'Florida State',
  GASO: 'Georgia Southern', GSU: 'Georgia State', GT: 'Georgia Tech', HAW: 'Hawaii', HOU: 'Houston',
  ILL: 'Illinois', IND: 'Indiana', IOWA: 'Iowa', ISU: 'Iowa State', JMU: 'James Madison',
  JVST: 'Jacksonville State', KENN: 'Kennesaw State', KENT: 'Kent State', KSU: 'Kansas State',
  KU: 'Kansas', LIB: 'Liberty', LOU: 'Louisville', LSU: 'LSU', LT: 'Louisiana Tech',
  'M-OH': 'Miami (OH)', MASS: 'Massachusetts', MD: 'Maryland', MEM: 'Memphis', MIA: 'Miami',
  MICH: 'Michigan', MINN: 'Minnesota', MISS: 'Ole Miss', MIZZ: 'Missouri', MRSH: 'Marshall',
  MSST: 'Mississippi State', MSU: 'Michigan State', MTSU: 'Middle Tennessee', NAVY: 'Navy',
  NCST: 'NC State', ND: 'Notre Dame', NEB: 'Nebraska', NEV: 'Nevada', NIU: 'Northern Illinois',
  NM: 'New Mexico', NMSU: 'New Mexico State', NW: 'Northwestern', ODU: 'Old Dominion', OHIO: 'Ohio',
  OKST: 'Oklahoma State', ORE: 'Oregon', OSU: 'Ohio State', OU: 'Oklahoma', PITT: 'Pittsburgh',
  PSU: 'Penn State', PUR: 'Purdue', RICE: 'Rice', RUT: 'Rutgers', SALA: 'South Alabama',
  SCAR: 'South Carolina', SDSU: 'San Diego State', SHSU: 'Sam Houston', SJSU: 'San Jose State',
  SMU: 'SMU', SOMI: 'Southern Miss', STAN: 'Stanford', SYR: 'Syracuse', TAMU: 'Texas A&M',
  TCU: 'TCU', TEM: 'Temple', TENN: 'Tennessee', TEX: 'Texas', TLSA: 'Tulsa', TOL: 'Toledo',
  TROY: 'Troy', TTU: 'Texas Tech', TUL: 'Tulane', TXST: 'Texas State', UAB: 'UAB', UCF: 'UCF',
  UCLA: 'UCLA', UCON: 'UConn', UGA: 'Georgia', UK: 'Kentucky', ULL: 'Louisiana', UNC: 'North Carolina',
  UNLV: 'UNLV', UNT: 'North Texas', USC: 'USC', USF: 'South Florida', USU: 'Utah State', UTAH: 'Utah',
  UTEP: 'UTEP', UTSA: 'UTSA', UVA: 'Virginia', VAN: 'Vanderbilt', VT: 'Virginia Tech',
  WAKE: 'Wake Forest', WASH: 'Washington', WIS: 'Wisconsin', WKU: 'Western Kentucky',
  WMU: 'Western Michigan', WVU: 'West Virginia', WYO: 'Wyoming'
}

// Legacy TEAM_NAMES for backwards compatibility (college sports + fallback)
export const TEAM_NAMES = {
  // NHL
  ANA: 'Anaheim Ducks', BOS: 'Boston Bruins', BUF: 'Buffalo Sabres', CGY: 'Calgary Flames',
  CBJ: 'Columbus Blue Jackets', COL: 'Colorado Avalanche', EDM: 'Edmonton Oilers', FLA: 'Florida Panthers',
  LAK: 'LA Kings', MTL: 'Montreal Canadiens', NJ: 'New Jersey Devils', NJD: 'New Jersey Devils', NSH: 'Nashville Predators',
  NYI: 'NY Islanders', NYR: 'NY Rangers', OTT: 'Ottawa Senators', SJS: 'San Jose Sharks',
  STL: 'St. Louis Blues', TBL: 'Tampa Bay Lightning', VAN: 'Vancouver Canucks', VGK: 'Vegas Golden Knights',
  WPG: 'Winnipeg Jets', WSH: 'Washington Capitals', SEA: 'Seattle Kraken',
  // CFB/CBB - Major schools
  ALA: 'Alabama', AUB: 'Auburn', UGA: 'Georgia', LSU: 'LSU', TENN: 'Tennessee', FLA: 'Florida',
  TAMU: 'Texas A&M', MISS: 'Ole Miss', MSST: 'Mississippi State', ARK: 'Arkansas', MIZZ: 'Missouri',
  VAN: 'Vanderbilt', UK: 'Kentucky', SCAR: 'South Carolina', OSU: 'Ohio State', MICH: 'Michigan',
  PSU: 'Penn State', MSU: 'Michigan State', WIS: 'Wisconsin', IOWA: 'Iowa', NEB: 'Nebraska',
  NW: 'Northwestern', MINN: 'Minnesota', ILL: 'Illinois', IND: 'Indiana', PUR: 'Purdue',
  RUT: 'Rutgers', MD: 'Maryland', TEX: 'Texas', OU: 'Oklahoma', OKST: 'Oklahoma State',
  BAY: 'Baylor', TCU: 'TCU', TTU: 'Texas Tech', KSU: 'Kansas State', KU: 'Kansas',
  ISU: 'Iowa State', WVU: 'West Virginia', CIN: 'Cincinnati', UCF: 'UCF', BYU: 'BYU',
  ARIZ: 'Arizona', ASU: 'Arizona State', COLO: 'Colorado', UTAH: 'Utah', USC: 'USC',
  UCLA: 'UCLA', ORE: 'Oregon', ORST: 'Oregon State', WASH: 'Washington', WSU: 'Washington State',
  CAL: 'California', STAN: 'Stanford', CLEM: 'Clemson', FSU: 'Florida State', VT: 'Virginia Tech',
  UVA: 'Virginia', UNC: 'North Carolina', NCST: 'NC State', DUKE: 'Duke', WAKE: 'Wake Forest',
  BC: 'Boston College', LOU: 'Louisville', PITT: 'Pittsburgh', SYR: 'Syracuse', GT: 'Georgia Tech',
  ND: 'Notre Dame', NOVA: 'Villanova', GTOWN: 'Georgetown', CREIG: 'Creighton', MARQ: 'Marquette',
  SETON: 'Seton Hall', PROV: 'Providence', BUTLER: 'Butler', XAVIER: 'Xavier', STJN: "St. John's",
  DEPAUL: 'DePaul', CONN: 'UConn', GONZ: 'Gonzaga', STMRY: "Saint Mary's", SANFR: 'San Francisco',
  SDIEGO: 'San Diego', SANTA: 'Santa Clara', PEPP: 'Pepperdine', LMCHI: 'Loyola Marymount',
  PORT: 'Portland', DAYT: 'Dayton', VCU: 'VCU', RICH: 'Richmond', STBON: 'St. Bonaventure',
  STLOU: 'Saint Louis', FORD: 'Fordham', GW: 'George Washington', GMAS: 'George Mason',
  LSAL: 'La Salle', DUQU: 'Duquesne', UMASS: 'UMass', DRAKE: 'Drake', LOYCHI: 'Loyola Chicago',
  BRAD: 'Bradley', ISIL: 'Illinois State', MIST: 'Missouri State', INST: 'Indiana State',
  VALS: 'Valparaiso', NIOWA: 'Northern Iowa', EVNS: 'Evansville', SIUE: 'SIU Edwardsville', 'SIU-Edwardsville': 'SIU Edwardsville',
  TROY: 'Troy', STFPA: 'St. Francis PA', CAMP: 'Campbell', SAMF: 'Samford', EWASH: 'Eastern Washington',
  PRTST: 'Portland State', WICHST: 'Wichita State', HOUST: 'Houston Christian', UNCG: 'UNC Greensboro',
  SDST: 'South Dakota State', DAVIS: 'UC Davis', GCU: 'Grand Canyon', TARL: 'Tarleton State',
  UTTCH: 'Utah Tech', UTUV: 'Utah Valley', MTSTM: "Mount St. Mary's", QUINN: 'Quinnipiac',
  BELMT: 'Belmont', UCIRVN: 'UC Irvine', UCSB: 'UC Santa Barbara', UCRIV: 'UC Riverside',
  UCSD: 'UC San Diego', CSBAK: 'CS Bakersfield', CALB: 'Cal Baptist', MEMPH: 'Memphis',
  NAVY: 'Navy', ARMY: 'Army', MRSH: 'Marshall', RICE: 'Rice', SMU: 'SMU', TUL: 'Tulane',
  TLSA: 'Tulsa', USF: 'South Florida', FAU: 'FAU', UAB: 'UAB', BSU: 'Boise State',
  SDSU: 'San Diego State', FRES: 'Fresno State', UNLV: 'UNLV', NEV: 'Nevada', CSU: 'Colorado State',
  WYO: 'Wyoming', USU: 'Utah State', HAW: 'Hawaii', SJSU: 'San Jose State', AF: 'Air Force',
  NM: 'New Mexico', TOL: 'Toledo', BGSU: 'Bowling Green', KENT: 'Kent State', AKRN: 'Akron',
  BUFF: 'Buffalo', OHIO: 'Ohio', M_OH: 'Miami OH', EMU: 'Eastern Michigan', CMU: 'Central Michigan',
  WMU: 'Western Michigan', NIU: 'Northern Illinois', BALL: 'Ball State',
  // Sun Belt / C-USA / other
  APP: 'Appalachian State', GASO: 'Georgia Southern', GAST: 'Georgia State', CCU: 'Coastal Carolina',
  JMU: 'James Madison', ODU: 'Old Dominion', MRSH: 'Marshall', SOAL: 'South Alabama',
  TXST: 'Texas State', ARST: 'Arkansas State', ULM: 'UL Monroe', ULL: 'Louisiana',
  UTEP: 'UTEP', UTSA: 'UTSA', UNT: 'North Texas', CHAR: 'Charlotte', MTSU: 'Middle Tennessee',
  WKU: 'Western Kentucky', FIU: 'FIU', LT: 'Louisiana Tech', NMSU: 'New Mexico State',
  JAX: 'Jacksonville State', SHSU: 'Sam Houston', CONN: 'UConn', UMASS: 'UMass',
  // More CBB mid-majors
  SOMI: 'SE Missouri State', APSU: 'Austin Peay', MTST: 'Murray State', TNTC: 'Tennessee Tech',
  ETSU: 'ETSU', CHAT: 'Chattanooga', MERC: 'Mercer', WOFF: 'Wofford', FURM: 'Furman',
  WEBB: 'Gardner-Webb', HAMP: 'Hampton', NORF: 'Norfolk State', NCAT: 'NC A&T', NCCEN: 'NC Central',
  SCST: 'SC State', FAMU: 'Florida A&M', GRAM: 'Grambling', SOUT: 'Southern', PRVU: 'Prairie View',
  TXSO: 'Texas Southern', JKST: 'Jackson State', ALST: 'Alabama State', AAMU: 'Alabama A&M',
  MVST: 'Mississippi Valley', ALCO: 'Alcorn State', ARK_PB: 'Arkansas Pine Bluff', BCOOK: 'Bethune-Cookman',
  DELST: 'Delaware State', COPP: 'Coppin State', MORG: 'Morgan State', UMES: 'MD Eastern Shore',
  HOW: 'Howard', ELO: 'Elon', DREX: 'Drexel', HOFS: 'Hofstra', NEU: 'Northeastern',
  UNCW: 'UNC Wilmington', WICH: 'College of Charleston', DEL: 'Delaware', TOWN: 'Towson',
  WILLI: 'William & Mary', MONM: 'Monmouth', FAIR: 'Fairfield', CANI: 'Canisius', SIENA: 'Siena',
  NIAG: 'Niagara', RIDER: 'Rider', MANH: 'Manhattan', IONA: 'Iona', QUIN: 'Quinnipiac',
  // Owls is likely Temple or Rice or FAU
  TEM: 'Temple'
}

// Helper to get display name for team - now league-aware
function titleCaseWords(value) {
  return String(value || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => {
      if (part.length <= 3 && part === part.toUpperCase()) return part
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    })
    .join(' ')
}

function compactLookupKey(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
}

const TEAM_LOGO_ALIASES = {
  nfl: {
    washingtoncommanders: 'WAS',
  },
  nba: {
    goldenstatewarriors: 'GSW',
    neworleanspelicans: 'NOP',
    newyorkknicks: 'NYK',
    phoenixsuns: 'PHX',
    sanantoniospurs: 'SAS',
    utahjazz: 'UTA',
    washingtonwizards: 'WAS',
  },
  nhl: {
    lakings: 'LAK',
    newjerseydevils: 'NJD',
    tampabaylightning: 'TBL',
  },
  mlb: {
    chiwhitesox: 'CHW',
    chicagowhitesox: 'CHW',
    milbrewers: 'MIL',
    milwaukeebrewers: 'MIL',
    nymets: 'NYM',
    newyorkmets: 'NYM',
    nyyankees: 'NYY',
    newyorkyankees: 'NYY',
    pitpirates: 'PIT',
    pittsburghpirates: 'PIT',
    sfgiants: 'SFG',
    sanfranciscogiants: 'SFG',
    stlouiscardinals: 'STL',
    tampabayrays: 'TBR',
    washingtonnationals: 'WSH',
  },
  cbb: {
    alabamacrimsontide: 'ALA',
    american: 'AME',
    arizonawildcats: 'ARIZ',
    arkansasrazorbacks: 'ARK',
    connecticuthuskies: 'UCONN',
    houstoncougars: 'HOU',
    illinoisfightingillini: 'ILL',
    iowahawkeyes: 'IOWA',
    michiganstatespartans: 'MSU',
    michiganwolverines: 'MICH',
    minnesotagoldengophers: 'MINN',
    northcarolinatarheels: 'UNC',
    notredamefightingi: 'ND',
    notredamefightingirish: 'ND',
    nebraskacornhuskers: 'NEB',
    purdueboilermakers: 'PUR',
    stjohnsredstorm: 'STJN',
    tennesseevolunteers: 'TENN',
    texaslonghorns: 'TEX',
    vanderbiltcommodores: 'VAN',
    westvirginiamountaineers: 'WVU',
  },
}

TEAM_LOGO_ALIASES.ncaab = TEAM_LOGO_ALIASES.cbb
TEAM_LOGO_ALIASES.cfb = TEAM_LOGO_ALIASES.ncaaf = {}

function getLeagueNameMap(leagueLower) {
  switch (leagueLower) {
    case 'nfl':
      return NFL_TEAM_NAMES
    case 'nba':
      return NBA_TEAM_NAMES
    case 'nhl':
      return NHL_TEAM_NAMES
    case 'mlb':
      return MLB_TEAM_NAMES
    case 'cfb':
    case 'ncaaf':
      return CFB_TEAM_NAMES
    case 'cbb':
    case 'ncaab':
    case 'ncaam':
    case 'ncaaw':
      return CBB_TEAM_NAMES
    default:
      return TEAM_NAMES
  }
}

function buildTeamCodeLookup(nameMap, aliases = {}) {
  const lookup = {}

  Object.entries(aliases).forEach(([alias, code]) => {
    lookup[compactLookupKey(alias)] = code
  })

  Object.entries(nameMap || {}).forEach(([code, displayName]) => {
    const compactCode = compactLookupKey(code)
    const compactDisplay = compactLookupKey(displayName)

    if (compactCode) lookup[compactCode] = code
    if (compactDisplay) lookup[compactDisplay] = code

    const words = String(displayName || '').split(/\s+/).filter(Boolean)
    if (words.length >= 2) {
      const firstWord = compactLookupKey(words[0])
      const lastWord = compactLookupKey(words.slice(-1).join(' '))
      const firstTwoWords = compactLookupKey(words.slice(0, 2).join(' '))

      if (firstWord && lastWord && !lookup[`${firstWord}${lastWord}`]) {
        lookup[`${firstWord}${lastWord}`] = code
      }
      if (firstTwoWords && lastWord && !lookup[`${firstTwoWords}${lastWord}`]) {
        lookup[`${firstTwoWords}${lastWord}`] = code
      }
    }
  })

  return lookup
}

const TEAM_CODE_LOOKUPS = {
  nfl: buildTeamCodeLookup(NFL_TEAM_NAMES, TEAM_LOGO_ALIASES.nfl),
  nba: buildTeamCodeLookup(NBA_TEAM_NAMES, TEAM_LOGO_ALIASES.nba),
  nhl: buildTeamCodeLookup(NHL_TEAM_NAMES, TEAM_LOGO_ALIASES.nhl),
  mlb: buildTeamCodeLookup(MLB_TEAM_NAMES, TEAM_LOGO_ALIASES.mlb),
  cbb: buildTeamCodeLookup(CBB_TEAM_NAMES, TEAM_LOGO_ALIASES.cbb),
  ncaab: buildTeamCodeLookup(CBB_TEAM_NAMES, TEAM_LOGO_ALIASES.ncaab),
  ncaam: buildTeamCodeLookup(CBB_TEAM_NAMES, TEAM_LOGO_ALIASES.ncaab),
  ncaaw: buildTeamCodeLookup(CBB_TEAM_NAMES, TEAM_LOGO_ALIASES.ncaab),
  cfb: buildTeamCodeLookup(CFB_TEAM_NAMES, TEAM_LOGO_ALIASES.cfb),
  ncaaf: buildTeamCodeLookup(CFB_TEAM_NAMES, TEAM_LOGO_ALIASES.ncaaf),
}

const TEAM_CODE_PREFIXES = Object.fromEntries(
  Object.entries(TEAM_CODE_LOOKUPS).map(([league, lookup]) => [
    league,
    Object.keys(lookup).sort((left, right) => right.length - left.length),
  ])
)

const TEAM_CANONICAL_CACHE = new Map()

function resolveCanonicalTeamCode(rawCanonical, leagueLower) {
  const cacheKey = `${leagueLower}|${rawCanonical || ''}`
  if (TEAM_CANONICAL_CACHE.has(cacheKey)) return TEAM_CANONICAL_CACHE.get(cacheKey)

  const raw = String(rawCanonical || '').trim()
  if (!raw) {
    TEAM_CANONICAL_CACHE.set(cacheKey, raw)
    return raw
  }

  const compactRaw = compactLookupKey(raw)
  const lookup = TEAM_CODE_LOOKUPS[leagueLower] || {}
  const prefixes = TEAM_CODE_PREFIXES[leagueLower] || []

  let resolved = lookup[compactRaw] || raw
  if (resolved === raw) {
    for (const alias of prefixes) {
      if (compactRaw.startsWith(alias) || alias.startsWith(compactRaw)) {
        resolved = lookup[alias]
        break
      }
    }
  }

  TEAM_CANONICAL_CACHE.set(cacheKey, resolved)
  return resolved
}

const KNOWN_TEAM_DISPLAY_NAMES = Array.from(
  new Set([
    ...Object.values(NFL_TEAM_NAMES),
    ...Object.values(NBA_TEAM_NAMES),
    ...Object.values(NHL_TEAM_NAMES),
    ...Object.values(MLB_TEAM_NAMES),
    ...Object.values(CBB_TEAM_NAMES),
    ...Object.values(CFB_TEAM_NAMES),
    ...Object.values(TEAM_NAMES),
  ].filter(Boolean))
)

const COMPACT_TEAM_DISPLAY_ALIASES = {
  CHIWHITESOX: 'Chicago White Sox',
  CHICAGOWHITESOX: 'Chicago White Sox',
  MILBREWERS: 'Milwaukee Brewers',
  PITPIRATES: 'Pittsburgh Pirates',
  NYMETS: 'New York Mets',
  NYYANKEES: 'New York Yankees',
  SFGIANTS: 'San Francisco Giants',
}

function resolveCompactTeamSlug(raw) {
  const compactRaw = compactLookupKey(raw)
  if (!compactRaw) return null

  let bestMatch = null
  let bestLength = 0

  for (const candidate of KNOWN_TEAM_DISPLAY_NAMES) {
    const compactCandidate = compactLookupKey(candidate)
    if (!compactCandidate) continue

    if (compactRaw === compactCandidate) {
      return candidate
    }

    if (compactRaw.startsWith(compactCandidate) && compactCandidate.length > bestLength) {
      bestMatch = candidate
      bestLength = compactCandidate.length
    }
  }

  return bestMatch
}

function prettifyUnknownTeamName(canonical) {
  const raw = String(canonical || '').trim()
  if (!raw) return ''
  const compactRaw = compactLookupKey(raw)

  if (raw.includes(' / ')) {
    return raw
      .split(' / ')
      .map((segment) => prettifyUnknownTeamName(segment))
      .join(' / ')
  }

  if (raw.includes('_')) {
    return titleCaseWords(raw.replace(/_/g, ' '))
  }

  if (/[a-z][A-Z]/.test(raw)) {
    return titleCaseWords(raw.replace(/([a-z])([A-Z])/g, '$1 $2'))
  }

  const compactAlias = COMPACT_TEAM_DISPLAY_ALIASES[compactRaw]
  if (compactAlias) {
    return compactAlias
  }

  const compactMatch = resolveCompactTeamSlug(raw)
  if (compactMatch) {
    return compactMatch
  }

  if (raw === raw.toUpperCase()) {
    return raw
  }

  return titleCaseWords(raw)
}

export const getTeamDisplayName = (canonical, league) => {
  if (!canonical) return ''

  const leagueLower = league?.toLowerCase() || ''
  const nameMap = getLeagueNameMap(leagueLower)
  const resolvedCanonical = resolveCanonicalTeamCode(canonical, leagueLower)

  return (
    nameMap[canonical] ||
    nameMap[resolvedCanonical] ||
    TEAM_NAMES[canonical] ||
    TEAM_NAMES[resolvedCanonical] ||
    prettifyUnknownTeamName(canonical)
  )
}
